import { siteInfo } from '@/mocks/homeData';

export default function HeroSection() {
  const handleScroll = (href: string) => {
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      className="relative min-h-[600px] flex items-center pt-[72px] pb-16 md:pb-20 overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-background-100 via-background-50 to-primary-50/40"></div>
      <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-primary-100/20 rounded-full blur-3xl -translate-y-1/2 translate-x-1/4"></div>
      <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-accent-100/20 rounded-full blur-3xl translate-y-1/2 -translate-x-1/4"></div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16 w-full">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 bg-primary-100/80 rounded-full mb-6">
              <span className="w-2 h-2 bg-primary-500 rounded-full animate-pulse"></span>
              <span className="text-xs font-semibold text-primary-700 whitespace-nowrap">实时更新中</span>
            </div>

            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-black text-foreground-950 font-heading leading-tight tracking-tight">
              {siteInfo.name}
              <span className="block text-primary-500 mt-2">最新吃瓜黑料曝光汇总平台</span>
            </h1>

            <p className="text-lg md:text-xl text-foreground-600 mt-4 font-semibold">
              {siteInfo.tagline}
            </p>

            <p className="text-sm md:text-base text-foreground-500 mt-5 leading-relaxed max-w-xl lg:max-w-none">
              {siteInfo.intro}
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-5 md:gap-8 mt-7">
              {siteInfo.stats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-2xl md:text-3xl font-black text-primary-500 font-heading">
                    {stat.value}
                  </div>
                  <div className="text-xs md:text-sm text-foreground-500 mt-1">
                    {stat.label}{stat.desc}
                  </div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4 mt-8">
              <a
                href="#cards"
                onClick={(e) => { e.preventDefault(); handleScroll('#cards'); }}
                className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 text-background-50 font-semibold rounded-lg hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer text-sm"
              >
                <i className="ri-fire-line text-lg"></i>
                立即吃瓜
              </a>
              <a
                href="#contact"
                onClick={(e) => { e.preventDefault(); handleScroll('#contact'); }}
                className="inline-flex items-center gap-2 px-8 py-3.5 border-2 border-foreground-200 text-foreground-700 font-semibold rounded-lg hover:border-primary-400 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer text-sm"
              >
                <i className="ri-mail-send-line text-lg"></i>
                投稿爆料
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-[500px] aspect-[4/3] rounded-2xl overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=dramatic%20abstract%20breaking%20news%20concept%20art%20with%20warm%20red%20amber%20and%20dark%20gradient%20tones%20editorial%20magazine%20aesthetic%20bold%20dynamic%20composition%20cinematic%20atmosphere%20geometric%20shapes%20glowing%20accents%20modern%20minimal%20design%20no%20text&width=800&height=600&seq=hero-main-visual&orientation=landscape"
                alt="爆料网 - 最新吃瓜黑料曝光汇总平台主视觉"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent"></div>
              <div className="absolute bottom-4 left-4 right-4">
                <div className="flex items-center gap-2">
                  <span className="px-2.5 py-1 bg-accent-500 text-background-50 text-xs font-bold rounded whitespace-nowrap">直播追踪</span>
                  <span className="text-xs text-background-50/90">实时黑料监控中</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}